import React, { useState, useEffect, useRef } from 'react';
import Component from '../../components/Component'
import { BASE_URL, handleDynamicRequest, SetAlert } from '../../components/CommonExport';

import { TextField, Grid, Autocomplete, Button, TextareaAutosize, IconButton, LinearProgress } from '@mui/material';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { DataGrid } from '@mui/x-data-grid';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Link } from 'react-router-dom';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import EditIcon from '@mui/icons-material/Edit'; // Import EditIcon
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import AwsConfig from '../../components/AwsConfig';
import AWS from 'aws-sdk';

const S3_BUCKET = process.env.REACT_APP_S3_BUCKET
const REGION = process.env.REACT_APP_REGION
const ACCESS_KEY = process.env.REACT_APP_ACCESS_KEY
const SECRET_ACCESS_KEY = process.env.REACT_APP_SECRET_ACCESS_KEY

function CompetitionImages() {
    const [competitionData, setCompetitionData] = useState([]);
    const [selectedCompetition, setSelectedCompetition] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [filteredData, setFilteredData] = useState(competitionData);
    const [modal, setModal] = useState(false);
    const [alertMessage, setAlertMessage] = useState({ success: '', error: '' });
    const [formData, setFormData] = useState({
        competition_id: null,
        logo_url: null,
    });
    const [selectedFile, setSelectedFile] = useState(null);
    const [isUploading, setIsUploading] = useState(false);
    const [uploadedImageUrl, setUploadedImageUrl] = useState('');
    const [limit, setLimit] = useState(30)
    const [offset, setOffset] = useState(0)
    const [modalEdit, setModalEdit] = useState(false);
    const toggleEdit = () => setModalEdit(!modalEdit);
    const toggle = () => setModal(!modal);

    // Clear alert messages after 5 seconds
    useEffect(() => {
        if (alertMessage.success || alertMessage.error) {
            const timer = setTimeout(() => {
                setAlertMessage({ success: '', error: '' });
            }, 5000);
            return () => clearTimeout(timer);
        }
    }, [alertMessage]);

    useEffect(() => {
        fetchCompetitionDataWithSearch(searchText, false);
    }, [limit, offset]);


    const handleNext = () => {
        const newOffset = offset + 30;
        setOffset(newOffset);
    };

    const handlePrevious = () => {
        const newOffset = Math.max(0, offset - 30);
        setOffset(newOffset);
    };

    // Separate function to handle search with reset
    const fetchCompetitionDataWithSearch = async (searchTerm, resetOffset = false) => {
        let requestBody = {};
        setCompetitionData([]);
        setFilteredData([]);
        
        const currentOffset = resetOffset ? 0 : offset;
        requestBody.search = searchTerm;
        requestBody.page = Math.floor(currentOffset / limit) + 1;
        requestBody.limit = limit;
        
        const method = 'GET';
        const url = `${BASE_URL}/admin/competitions/list?search=${searchTerm}&page=${requestBody.page}&limit=${requestBody.limit}`;
        const wrongResponse = () => {
            setAlertMessage({ success: '', error: 'Wrong Credentials' });
        };
        const rightResponse = (data) => {
            if (data && data.data && data.data.competitions) {
                let updatedFilteredData = data.data.competitions.map((competition, index) => {
                    return {
                        ...competition,
                        id: index + 1 // Increment index by 1 to start from 1
                    };
                });
                setFilteredData(updatedFilteredData);
                setCompetitionData(updatedFilteredData);
            }
        };
        try {
            await handleDynamicRequest(method, url, requestBody, wrongResponse, rightResponse);
        } catch (error) {
            wrongResponse();
        }
    };

    useEffect(() => {
        // Reset to page 1 when searching
        setOffset(0);
        
        // Debounce search to prevent too many API calls
        const timeoutId = setTimeout(() => {
            fetchCompetitionDataWithSearch(searchText, true);
        }, 300); // 300ms debounce
        
        return () => clearTimeout(timeoutId);
    }, [searchText]);

    const columns = [
        { field: 'title', headerName: 'Competition Name', flex: 1 },
        { field: 'short_title', headerName: 'Short Title', flex: 1 },
        {
            field: 'logo',
            headerName: 'Logo',
            flex: 1,
            renderCell: (params) => (
                params.row.logo ? (
                    <a href={params.row.logo} target="_blank" rel="noopener noreferrer">
                        <img src={params.row.logo} alt={params.row.title} style={{ width: '70px', height: '70px' }} />
                    </a>
                ) : (
                    <span>No Logo</span>
                )
            )
        },
        {
            field: 'cta',
            headerName: 'CTA',
            flex: 1,
            renderCell: (params) => (
                params.row.logo ? (
                    <IconButton className='back-btn' style={{ background: '#ffffff' }} onClick={() => { toggleEdit(); setSelectedCompetition(params.row); }}>
                        <EditIcon style={{ cursor: 'pointer', color: '#ffffff' }} />
                    </IconButton>
                ) : (
                    <IconButton className='back-btn' style={{ background: '#ffffff' }} onClick={() => { toggleEdit(); setSelectedCompetition(params.row); }}>
                        <AddIcon style={{ cursor: 'pointer', color: '#ffffff' }} />
                    </IconButton>
                )
            )
        },
    ];

    const handleSearch = (event) => {
        const value = event.target.value.toLowerCase();
        setSearchText(value);
    };

    const handleSubmit = () => {
        console.log('selectedCompetition', selectedCompetition);
        console.log('selectedFile', selectedFile);
        
        if (selectedFile && selectedCompetition.cid) {
            setIsUploading(true);
            setAlertMessage({ success: '', error: '' });
            
            // Create FormData for the file upload
            const formData = new FormData();
            formData.append('logo', selectedFile);

            const url = `${BASE_URL}/admin/competitions/${selectedCompetition.cid}/logo?logo=null`;
            
            const wrongResponse = (error) => {
                setAlertMessage({ success: '', error: `Failed to upload logo: ${error}` });
                setIsUploading(false);
            };
            const rightResponse = (data) => {
                fetchCompetitionDataWithSearch(searchText, false);
                setUploadedImageUrl('');
                setSelectedFile(null);
                setSelectedCompetition(null);
                toggle();
                setAlertMessage({ success: 'Logo uploaded successfully', error: '' });
                setIsUploading(false);
            };

            // Use fetch for file upload with FormData and timeout
            const controller = new AbortController();
            const timeoutId = setTimeout(() => controller.abort(), 30000); // 30 second timeout

            fetch(url, {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJhcGkuZGV2Lnh5ei5jb20iLCJhdWQiOiJ4eXouY29tIiwic3ViIjoiOTc5ZjhlZjYtZjA5MS00YjI4LWI0N2MtNmM4ZjFjNjNjZjQzIiwiaWF0IjoxNzU0NDEwMjg5LCJleHAiOjE3ODU1MTQyODksInBybSI6IjU3MWYwYmE3ZTJmODM4MDI2ZGU1ZmE3MzY4NzA5ZTc1YWIyYTE5YzZkMGE5MTQxMTRkZmJmOGY3MDdlMmQyZTY4ZWViMzk5YjY2YWQzYzY4Zjg4MDc5MWMzODViMDU4ODZiMWQ2MzBkM2M2ZDc5ODQ5ZjFiZmQzZGNjZDBiNTY3In0.0Yn1WAiX69fSN9_IRWv42KlY_HFOC_xxtUplIiGr-rI'
                },
                body: formData,
                signal: controller.signal
            })
            .then(response => {
                clearTimeout(timeoutId);
                if (!response.ok) {
                    throw new Error(`HTTP ${response.status}: ${response.statusText}`);
                }
                return response.json();
            })
            .then(data => rightResponse(data))
            .catch(error => {
                clearTimeout(timeoutId);
                if (error.name === 'AbortError') {
                    wrongResponse('Upload timeout - please try again');
                } else {
                    console.error('Upload error:', error);
                    wrongResponse(error.message);
                }
            });
        } else {
            setAlertMessage({ success: '', error: 'Please select a file and competition' });
        }
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedFile(file);
            
            // Create a preview URL for the selected file (only if file is small)
            if (file.size < 5 * 1024 * 1024) { // Only for files less than 5MB
                const previewUrl = URL.createObjectURL(file);
                setUploadedImageUrl(previewUrl);
            } else {
                setUploadedImageUrl(file.name); // Just show filename for large files
            }
            
            setIsUploading(false);
            
            // Clear any previous error messages
            setAlertMessage({ success: '', error: '' });
        }
    };

    const handleDeleteImage = () => {
        // Clear the selected file and preview
        setSelectedFile(null);
        setUploadedImageUrl('');
        
        // Reset the file input
        const fileInput = document.getElementById('file-input');
        if (fileInput) {
            fileInput.value = '';
        }
    };

    const handleButtonClick = () => {
        document.getElementById('file-input').click();
    };

    const handleEditSubmit = () => {
        console.log('selectedCompetition', selectedCompetition);
        console.log('selectedFile', selectedFile);
        
        if (selectedFile && selectedCompetition.cid) {
            setIsUploading(true);
            setAlertMessage({ success: '', error: '' });
            
            // Create FormData for the file upload
            const formData = new FormData();
            formData.append('logo', selectedFile);

            const url = `${BASE_URL}/admin/competitions/${selectedCompetition.cid}/logo?logo=null`;
            
            const wrongResponse = (error) => {
                setAlertMessage({ success: '', error: `Failed to upload logo: ${error}` });
                setIsUploading(false);
            };
            const rightResponse = (data) => {
                fetchCompetitionDataWithSearch(searchText, false);
                setUploadedImageUrl('');
                setSelectedFile(null);
                toggleEdit();
                setAlertMessage({ success: 'Logo uploaded successfully', error: '' });
                setIsUploading(false);
            };

            // Use fetch for file upload with FormData and timeout
            const controller = new AbortController();
            const timeoutId = setTimeout(() => controller.abort(), 30000); // 30 second timeout

            fetch(url, {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJhcGkuZGV2Lnh5ei5jb20iLCJhdWQiOiJ4eXouY29tIiwic3ViIjoiOTc5ZjhlZjYtZjA5MS00YjI4LWI0N2MtNmM4ZjFjNjNjZjQzIiwiaWF0IjoxNzU0NDEwMjg5LCJleHAiOjE3ODU1MTQyODksInBybSI6IjU3MWYwYmE3ZTJmODM4MDI2ZGU1ZmE3MzY4NzA5ZTc1YWIyYTE5YzZkMGE5MTQxMTRkZmJmOGY3MDdlMmQyZTY4ZWViMzk5YjY2YWQzYzY4Zjg4MDc5MWMzODViMDU4ODZiMWQ2MzBkM2M2ZDc5ODQ5ZjFiZmQzZGNjZDBiNTY3In0.0Yn1WAiX69fSN9_IRWv42KlY_HFOC_xxtUplIiGr-rI'
                },
                body: formData,
                signal: controller.signal
            })
            .then(response => {
                clearTimeout(timeoutId);
                if (!response.ok) {
                    throw new Error(`HTTP ${response.status}: ${response.statusText}`);
                }
                return response.json();
            })
            .then(data => rightResponse(data))
            .catch(error => {
                clearTimeout(timeoutId);
                if (error.name === 'AbortError') {
                    wrongResponse('Upload timeout - please try again');
                } else {
                    console.error('Upload error:', error);
                    wrongResponse(error.message);
                }
            });
        } else {
            setAlertMessage({ success: '', error: 'Please select a file and competition' });
        }
    }

    return (
        <Component>
            <div class="page-body">
                <div class="container-fluid">
                    <div class="page-header">
                        <div class="row">
                            <div className="col-sm-12">
                                <div className="d-flex align-items-center ">
                                    <IconButton style={{ background: '#FFFFFF' }} component={Link} to="/dashboards">
                                        <ArrowBackIcon />
                                    </IconButton>
                                    <h3 style={{ marginLeft: '20px' }}>Competition Images</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="card">
                                <div class="card-body">
                                    <Grid container spacing={2} sx={{ marginBottom: '20px' }}>
                                        <Grid item xs={12} sm={12} md={10}>
                                            <TextField
                                                fullWidth
                                                label="Search Competitions"
                                                variant="outlined"
                                                value={searchText}
                                                onChange={handleSearch}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={2}>
                                            <Button style={{ width: '100%', height: '100%' }} variant="contained" color="primary" onClick={toggle}>
                                                Add Logo
                                            </Button>
                                        </Grid>
                                    </Grid>
                                    {alertMessage.success && (
                                        <div style={{ color: 'green', marginBottom: '10px' }}>
                                            {alertMessage.success}
                                        </div>
                                    )}
                                    {alertMessage.error && (
                                        <div style={{ color: 'red', marginBottom: '10px' }}>
                                            {alertMessage.error}
                                        </div>
                                    )}
                                    <DataGrid
                                        rows={filteredData}
                                        columns={columns}
                                        pageSize={25}
                                        rowsPerPageOptions={[25, 50, 100]}
                                        getRowId={(row) => row.id}
                                        rowHeight={100}
                                    />
                                    <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', margin: '20px 0' }}>
                                        <button onClick={handlePrevious} disabled={offset === 0}>
                                            Previous
                                        </button>
                                        <span>Page: {(offset / limit) + 1}</span>
                                        <button onClick={handleNext}>
                                            Next
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <Modal isOpen={modal} toggle={toggle}>
                <ModalHeader toggle={toggle}>Add Competition Logo</ModalHeader>
                <ModalBody>
                    <form className="form theme-form">
                        <Grid container spacing={4}>
                            <Grid item xs={12}>
                                <Autocomplete
                                    id="competition-filter"
                                    options={competitionData}
                                    getOptionLabel={(option) => option.title}
                                    value={selectedCompetition}
                                    onChange={(event, newValue) => {
                                        setSelectedCompetition(newValue);
                                    }}
                                    renderInput={(params) => <TextField {...params} label="Select Competition" variant="outlined" fullWidth />}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    placeholder="Competition Logo"
                                    value={selectedFile ? selectedFile.name : ''}
                                    InputProps={{
                                        readOnly: true,
                                        endAdornment: (
                                            <Button variant="contained" onClick={handleButtonClick}>
                                                Upload
                                            </Button>
                                        )
                                    }}
                                />
                                <input
                                    type="file"
                                    accept="image/*"
                                    onChange={handleFileChange}
                                    style={{ display: 'none' }}
                                    id="file-input"
                                />
                                {uploadedImageUrl && (
                                    <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                                        {uploadedImageUrl.startsWith('blob:') ? (
                                            <img src={uploadedImageUrl} alt="Competition" style={{ width: '100px', height: '100px', marginRight: '10px' }} />
                                        ) : (
                                            <div style={{ padding: '10px', border: '1px dashed #ccc', marginRight: '10px' }}>
                                                {uploadedImageUrl}
                                            </div>
                                        )}
                                        <IconButton onClick={handleDeleteImage} color="secondary">
                                            <DeleteIcon />
                                        </IconButton>
                                    </div>
                                )}
                            </Grid>
                        </Grid>
                    </form>
                </ModalBody>
                {isUploading && <LinearProgress sx={{ marginBottom: '10px' }} />}
                <ModalFooter >
                    <Button color="primary" onClick={handleSubmit} disabled={isUploading}>
                        {isUploading ? 'Uploading...' : 'Submit'}
                    </Button>{' '}
                    <Button color="secondary" onClick={toggle} disabled={isUploading}>Cancel</Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={modalEdit} toggle={toggleEdit}>
                <ModalHeader toggle={toggleEdit}>Edit Competition Logo</ModalHeader>
                <ModalBody>
                    <form className="form theme-form">
                        <Grid container spacing={4}>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    label="Competition Name"
                                    value={selectedCompetition?.title || ''}
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    placeholder="Competition Logo"
                                    value={selectedFile ? selectedFile.name : (selectedCompetition?.logo ? 'Current Logo' : '')}
                                    InputProps={{
                                        readOnly: true,
                                        endAdornment: (
                                            <Button variant="contained" onClick={handleButtonClick}>
                                                Upload
                                            </Button>
                                        ),
                                    }}
                                />
                                <input
                                    type="file"
                                    accept="image/*"
                                    onChange={handleFileChange}
                                    style={{ display: 'none' }}
                                    id="file-input"
                                />
                                {uploadedImageUrl && (
                                    <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                                        {uploadedImageUrl.startsWith('blob:') ? (
                                            <img src={uploadedImageUrl} alt="Competition" style={{ width: '100px', height: '100px', marginRight: '10px' }} />
                                        ) : (
                                            <div style={{ padding: '10px', border: '1px dashed #ccc', marginRight: '10px' }}>
                                                {uploadedImageUrl}
                                            </div>
                                        )}
                                        <IconButton onClick={handleDeleteImage} color="secondary">
                                            <DeleteIcon />
                                        </IconButton>
                                    </div>
                                )}
                                {selectedCompetition?.logo && !uploadedImageUrl && (
                                    <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                                        <img src={selectedCompetition.logo} alt="Current Logo" style={{ width: '100px', height: '100px', marginRight: '10px' }} />
                                        <span>Current Logo</span>
                                    </div>
                                )}
                            </Grid>
                        </Grid>
                    </form>
                </ModalBody>
                {isUploading && <LinearProgress sx={{ marginBottom: '10px' }} />}
                <ModalFooter>
                    <Button color="primary" onClick={handleEditSubmit} disabled={isUploading}>
                        {isUploading ? 'Uploading...' : 'Submit'}
                    </Button>
                    <Button color="secondary" onClick={toggleEdit} disabled={isUploading}>Cancel</Button>
                </ModalFooter>
            </Modal>
        </Component>
    )
}

export default CompetitionImages
